"use strict";

var __assign = this && this.__assign || function () {
  __assign = Object.assign || function (t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
      s = arguments[i];

      for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
    }

    return t;
  };

  return __assign.apply(this, arguments);
};

Object.defineProperty(exports, "__esModule", {
  value: true
});

var jsx_runtime_1 = require("react/jsx-runtime");

var prop_types_1 = require("prop-types");

var react_router_dom_1 = require("react-router-dom");

require("./index.css");

var Breadcrumbs = function (_a) {
  var breadcrumbs = _a.breadcrumbs;
  return breadcrumbs.map(function (crumb, index) {
    var testId = "breadcrumb-" + crumb.text.toLowerCase().replace(/ /g, '-');
    return index === breadcrumbs.length - 1 ? (0, jsx_runtime_1.jsx)("span", __assign({
      className: "breadcrumb-text",
      "data-testid": testId
    }, {
      children: crumb.text
    }), crumb.path) : (0, jsx_runtime_1.jsx)(react_router_dom_1.Link, __assign({
      to: crumb.path,
      className: "breadcrumb-link",
      "data-testid": testId
    }, {
      children: crumb.text
    }), crumb.path);
  });
};

Breadcrumbs.propTypes = {
  // eslint-disable-next-line react/forbid-prop-types
  breadcrumbs: prop_types_1.array.isRequired
};
exports.default = Breadcrumbs;